function render(scene, views, afterViewsRender) {
  const { mainCanvas } = scene;

  beforeWorldRender(mainCanvas);

  drawViews(mainCanvas, views);

  if (afterViewsRender) afterViewsRender(mainCanvas);

  mainCanvas.context.restore();
}

function beforeWorldRender(canvas) {
  const { context, width, height } = canvas;

  context.clearRect(0, 0, width, height);

  context.save();

  // transform origin to center
  context.translate(Math.round(canvas.width / 2), Math.round(canvas.height / 2));

  // user scale
  context.scale(canvas.scale, canvas.scale);

  // apply scaled user translate
  context.translate(Math.round(canvas.translateX), Math.round(canvas.translateY));
}

function drawViews(canvas, views) {
  views.forEach(view => canvas.context.drawImage(
    view.canvas.canvas,
    0, 0, view.canvas.width, view.canvas.height,
    0, 0, view.canvas.width, view.canvas.height,
  ));
}

export default render;
